import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { SnackService } from '@shared/services/snack.service';
import { AuthService } from '@shared/services/auth.service';
import { ApiService } from '@shared/services/api.service';
import { ScrollService } from '@shared/services/scroll.service';
import { AdsService } from '@shared/services/ads.service';
import { LocaleService } from '@shared/services/locale.service';
import { ViewportService } from '@shared/services/viewport.service';
import { TimeService } from '@shared/services/time.service';
import { NumbersService } from '@shared/services/numbers.service';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ViewCommentsComponent } from '../../ads/ad/view-comments/view-comments.component';
import { Form } from '@angular/forms';
import { BoostAdDialogComponent } from '@shared/components/boost-ad-dialog/boost-ad-dialog.component';
import { ButtonType } from '@shared/components/button/button.component';
import { User } from '@core/models';
import { AdsApi } from '@core/apis/ads.api';

@Component({
	selector: 'app-user-ads',
	templateUrl: './user-ads.component.html',
	styleUrls: ['./user-ads.component.scss'],
})
export class UserAdsComponent implements OnInit {
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private title: Title,
		private snack: SnackService,
		private auth: AuthService,
		private api: ApiService,
		private scroll: ScrollService,
		private dialog: MatDialog,
		public adsService: AdsService,
		public locale: LocaleService,
		public viewport: ViewportService,
		public time: TimeService,
		public numbers: NumbersService,
		private cdf: ChangeDetectorRef,
		private adsApi: AdsApi
	) {}

	loading: boolean = true;
	isMe: boolean;
	user: User = this.auth.user();
	watchlist: boolean;
	ads: any[];
	page: number = 1;
	pages: number = 1;
	userAdsFormData: FormData = new FormData();
	dealersAdsFormData: FormData = new FormData();
	dealerInfo: object;
	iAmDealer: boolean = false;
	complete: boolean = false;
	date: Date;
	readonly buttonType = ButtonType;
	adFilterText: string;
	totalAdsLength: string;

	filterValueMappings: Record<string, string> = {
		isFree: this.locale.translations['user']['user-ads']['filter']['n669'],
		isVip: this.locale.translations['user']['user-ads']['filter']['n671'],
		isVipPlus: this.locale.translations['n710'],
		isExpired: this.locale.translations['user']['user-ads']['filter']['n672'],
		isPending: this.locale.translations['user']['user-ads']['filter']['n673'],
	};

	// comment box
	openDialog(adID: string, adVip, adVipPlus) {
		if (adVip !== '1' && adVipPlus !== '1') {
			this.snack.open(this.locale.translations['payment']['n341']);
		} else {
			const Commentsdialog = this.dialog.open(ViewCommentsComponent, {
				maxWidth: '700px',
				width: '96%',
				maxHeight: '700px',
				data: {
					adID: adID,
					lang: this.locale.lang,
					// userID: this.user['userID'],
					userAd: this.user['userID'],
					vip: adVip,
					vipPlus: adVipPlus,
				},
			});

			Commentsdialog.afterClosed().subscribe((data) => {
				this.cdf.detectChanges();
			});
		}
	}
	// analytics page
	openAnalytics(adID: string, adVip, adVipPlus) {
		if (adVip !== '1' && adVipPlus !== '1') {
			this.snack.open(this.locale.translations['payment']['n341']);
		} else {
			this.router.navigate(['/ads-analytics'], {
				queryParams: {
					adID: adID,
				},
			});
		}
	}

	// previous page clicked
	onPreviousPage() {
		this.router.navigate([], {
			relativeTo: this.route,
			queryParams: {
				page: this.page !== 2 ? --this.page : undefined,
			},

			queryParamsHandling: 'merge',
		});
	}

	// next page clicked
	onNextPage() {
		this.router.navigate([], {
			relativeTo: this.route,
			queryParams: {
				page: ++this.page,
			},
			queryParamsHandling: 'merge',
		});
	}

	// page number clicked
	onPage(pg: number) {
		if (pg === 1) {
			pg = undefined;
		}

		this.router.navigate([], {
			relativeTo: this.route,
			queryParams: {
				page: pg,
			},
			queryParamsHandling: 'merge',
		});
	}

	onDelete(adID: string) {
		const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
			width: this.locale.lang == 'ku' ? '385px' : '320px',
			height: '140px',
			data: {
				message: this.locale.translations['ads']['ad']['n386'],
				yes: this.locale.translations['ads']['ad']['n388'],
				no: this.locale.translations['ads']['ad']['n387'],
				colors: {
					yes: 'warn',
					no: 'warn',
				},
			},
		});

		dialogRef.afterClosed().subscribe((result) => {
			const adFormData: FormData = new FormData();
			adFormData.append('lang', this.locale.lang);
			adFormData.append('userID', this.user['userID']);
			adFormData.append('adID', adID);

			this.userAdsFormData.set('lang', this.locale.lang);
			this.userAdsFormData.set('id', this.user['userID']);
			this.userAdsFormData.set('page', this.page.toString());

			// ad sold
			if (result === true) {
				this.loading = true;
				this.api.sell(adFormData).subscribe((res) => {
					this.getUserAds(this.userAdsFormData);
					this.snack.open(this.locale.translations['user']['user-ads']['delete-ad']['s18']);
				});

				// ad not sold open a new popup to confirm for deleting ad
			} else if (result === false) {
				const dialogRef_1 = this.dialog.open(ConfirmationDialogComponent, {
					width: this.locale.lang == 'ku' ? '385px' : '320px',
					height: '160px',
					data: {
						message: this.locale.translations['n722'],
						yes: 'Yes',
						no: 'No',
						colors: {
							yes: 'warn',
						},
					},
				});

				// delete the ad
				dialogRef_1.afterClosed().subscribe((result) => {
					if (result) {
						this.loading = true;
						this.api.deleteAd(adFormData).subscribe((res) => {
							if (this.ads.length === 1 && this.page !== 1) {
								this.snack.open(this.locale.translations['user']['user-ads']['delete-ad']['s15']);
								this.onPreviousPage();
								this.loading = false;
								
							} else {
								this.getUserAds(this.userAdsFormData);

								this.snack.open(this.locale.translations['user']['user-ads']['delete-ad']['s15']);
							}

							this.adsApi.upgradeAd.next(true);
						});
					}
				});
			}
		});
	}

	onUnWatch(index: number) {
		const formData: FormData = new FormData();
		formData.append('lang', this.locale.lang);
		formData.append('userID', this.user['userID']);
		formData.append('adID', this.ads[index]['id']);
		formData.append('watch', '0');

		this.api.watch(formData).subscribe((res) => {
			if (this.ads.length === 1 && this.page !== 1) {
				this.onPreviousPage();
			} else {
				this.ads.splice(index, 1);
				this.snack.open(res['message']);
			}
		});
	}

	onAdClick() {
		this.scroll.save(window.scrollX, window.scrollY, this.router.url);
	}

	onCarouselClick(ad, event) {
		if (event.target.className != 'carousel-control-next-icon' && event.target.className != 'carousel-control-prev-icon') {
			this.router.navigate(['/ad/' + ad['id']]);
			this.scroll.save(window.scrollX, window.scrollY, this.router.url);
		}
	}

	scrollToSavedLocation() {
		// scroll to stored position
		const _scroll = this.scroll.fetch();
		if (_scroll !== undefined && _scroll?.['trigger'] === true) {
			setTimeout(() => {
				window.scrollTo({ left: _scroll['xpos'], top: _scroll['ypos'] });
			}, 0);
		}

		// clear scroll
		this.scroll.save(undefined, undefined, undefined, undefined);
	}

	// check add complete or incomplete

	onAddComplete(ad) {
		if (ad['title'] !== null && ad['location'] !== '' && ad['subCatID'] !== 0 && ad['image'] !== '' && ad['description'] !== null && ad['price'] !== '0') {
			this.complete = true;
		} else {
			this.complete = false;
		}

		return this.complete;
	}

	onHandleClick(ad) {
		this.router.navigate(['/payment/tier'], {
			queryParams: {
				adID: ad['id'],
			},
		});
	}

	selectAdFilter(selectedFillter: string) {
		let filterValue;
		switch (selectedFillter) {
			case 'Free Ads':
				filterValue = 'isFree';
				break;

			case 'VIP Ads':
				filterValue = 'isVip';
				break;
			case 'VIP+ Ads':
				filterValue = 'isVipPlus';
				break;
			case 'Expired Ads':
				filterValue = 'isExpired';
				break;
			case 'Pending Ads':
				filterValue = 'isPending';
				break;
		}

		this.router.navigate([], {
			relativeTo: this.route,
			queryParams: {
				page: undefined,
				filterValue: filterValue,
			},
			queryParamsHandling: 'merge',
		});
	}

	getUserAds(formData) {
		this.api.userAds(formData).subscribe((res) => {
			if (res['status'] === '1') {
				this.ads = res['response']['posted'];
				this.pages = res['response']['pages'];
				this.totalAdsLength = res['response']['totalRows'];
				this.scrollToSavedLocation();
				this.loading = false;
			} else {
				this.ads = [];
				this.loading = false;
			}
		});
	}

	ngOnInit(): void {
		this.route.params.subscribe((params: Params) => {
			// check if user param id is currently logged in
			if (this.user && this.user['userID'] === params['userID']) {
				this.isMe = true;
				this.title.setTitle(this.locale.translations['app-update']['n328']['n328-2'] + ' | ' + this.locale.translations['header']['n0']);
			} else {
				this.isMe = false;
			}

			this.userAdsFormData.append('lang', this.locale.lang);
			this.userAdsFormData.append('userID', params['userID']);

			this.route.queryParams.subscribe((queries: Params) => {
				if (queries['page']) {
					this.page = +queries['page'];
					this.userAdsFormData.append('page', this.page.toString());
				}

				if (queries['filterValue']) {
					this.userAdsFormData.append(queries['filterValue'], '1');
				}

				this.adFilterText = this.filterValueMappings[queries?.['filterValue']] || this.locale.translations['dealer']['n351'];

				if (queries['tab'] === 'watchlist' && this.isMe) {
					this.title.setTitle(this.locale.translations['header']['n8'] + ' | ' + this.locale.translations['header']['n0']);
					this.watchlist = true;

					this.api.userWatchlist(this.userAdsFormData).subscribe((res) => {
						if (res['status'] === '1') {
							this.ads = res['response']['watching'];
							this.pages = res['response']['pages'];
							this.scrollToSavedLocation();
							this.loading = false;
						} else {
							this.ads = [];
							this.loading = false;
						}
					});
				} else {
					this.title.setTitle(this.locale.translations['app-update']['n328']['n328-2'] + ' | ' + this.locale.translations['header']['n0']);
					this.watchlist = false;
					this.getUserAds(this.userAdsFormData);
				}
			});
		});
	}

	getExpiryDate(datevalue: string) {
		this.date = new Date(datevalue);
		this.date.setDate(this.date.getDate() + 5);
		return this.time.fromNow(this.date.toString());
	}

	getObjectLength(obj) {
		if (Object.keys(obj).length === 0) {
			return true;
		}
	}
}
